import { NavigationLink } from '../navigation/navigation-stub/models';
import NavigationStub from '../navigation/navigation-stub/NavigationStub';

import { URL_LANGUAGE_ENUM } from 'utils/constants';

function buildNavigationLinks(nav: NavigationLink) {
  if (isDropdown(nav)) {
    return buildDropdownButton(nav);
  } else {
    return buildDirectLink(nav);
  }
}

function buildDropdownButton(nav: NavigationLink) {
  const sectionsWithoutFirstSection = nav.children ? nav.children.slice(1) : [];

  return {
    children: sectionsWithoutFirstSection.map((navChild) => buildSection(navChild, nav)),
    url: nav.directPath,
    name: nav.name,
  };
}

function buildDirectLink(nav: NavigationLink, parentNav = {} as NavigationLink) {
  return {
    url: nav.directPath || parentNav.directPath,
    name: nav.name,
  };
}

function buildSection(nav: NavigationLink, parentNav: NavigationLink) {
  return {
    heading: nav.name,
    links: buildSectionNavLinks(nav),
    sectionLink: {
      title: nav.name,
      url: nav.directPath || parentNav.directPath,
    },
  };
}

function buildSectionNavLinks(nav: NavigationLink) {
  const linksWithoutSectionLink = nav.children ? nav.children.slice(1) : [];

  return linksWithoutSectionLink.map((navChild) => ({
    title: navChild.name,
    url: navChild.directPath || nav.directPath,
  }));
}

function isDropdown(nav: NavigationLink) {
  return nav.children && nav.children?.length > 0;
}

export function generateLinksWithSections(urlLanguage: URL_LANGUAGE_ENUM) {
  const navigationLinks = NavigationStub.get(urlLanguage)!.getLinks();

  return navigationLinks.map((nav: NavigationLink) => buildNavigationLinks(nav));
}
